import React from 'react';
import { Form } from 'react-bootstrap';
import { Controller, FieldError, useFormContext } from 'react-hook-form';

import DateFormControl from 'components/FormControl/Date/DateFormControl';

const HookDateFormControl = (props: any) => {
    const {
        name,
        label,
        defaultValue,
        rules,
        isClearable,
        hideCalendar = true,
        disabled = false,
        className = ``,
    } = props;
    const form = useFormContext();

    return (
        <>
            <Form.Label>
                {label}
                {rules?.required && <span className="required-mark" />}
            </Form.Label>
            <Controller
                name={name}
                render={({ field }) => {
                    return (
                        <DateFormControl
                            className={`form-date-input date-input ${className} ${disabled && `input-disabled`}`}
                            {...field}
                            required={rules?.required}
                            maxDate={new Date()}
                            onChange={(d: string | null) => {
                                field.onChange(d);
                                if (props.onChange) {
                                    props.onChange(d);
                                }
                            }}
                            isClearable={isClearable}
                            disabled={disabled}
                            hideCalendar={hideCalendar}
                        />
                    );
                }}
                control={form.control}
                defaultValue={defaultValue}
                rules={rules}
            />
            {form.formState.errors[name] && (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                    {(form.formState.errors[name] as FieldError)?.message}
                </div>
            )}
        </>
    );
};

export default HookDateFormControl;
